(function (scope) {
  "use strict";

  var PrintModalQuote = (scope.PrintModalQuote = function (controller, design) {
    this.controller = controller;
    this.design = design;
    this.$el = $("#PrintModalQuote");
    this.form = this.$el.find("form");
    this.form.find("input[type=submit]").click(this.submitForm.bind(this));
    this.$el.on("click", ".modal-back", this.back.bind(this));
    this.$el.find(".quote-close").click(this.closeModal.bind(this));
  });

  PrintModalQuote.prototype.closeModal = function (e) {
    e.preventDefault();
    this.hideModal();
    this.$el.find("#quote_submit_div").show();
    this.$el.find("#quote_close_div").hide();
    this.$el.find(".form_error > div").text("");
    this.$el.find(".icon-close").show();
    this.form.trigger("reset");
    this.form.show();
  };

  PrintModalQuote.prototype.hideModal = function () {
    this.$el.hide();
  };

  PrintModalQuote.prototype.showModal = function (cartitems, type, extra_data) {
    this.cartitems = cartitems;
    this.type = type;
    this.extra_data = extra_data;
    this.$el.fadeIn(400, "linear");
  };

  PrintModalQuote.prototype.back = function () {
    this.hideModal();
  };

  PrintModalQuote.prototype.submitForm = function (e) {
    e.preventDefault();
    var data = this.form.serialize();
    if (this.cartitems) data += "&cartitems=" + JSON.stringify(this.cartitems);
    if (this.type) data += "&type=" + this.type;
    if (this.extra_data)
      data += "&extra_data=" + JSON.stringify(this.extra_data);
    $.ajax({
      context: this,
      type: "post",
      data: data,
      url: this.form.attr("action"),
      headers: {
        "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
          .value,
      },
      success: function (data) {
        if (data.success) {
          this.$el.find("#quote_submit_div").hide();
          this.$el.find("#quote_close_div").show();
          this.$el.find(".icon-close").hide();
          this.form.hide();
        }
        this.printErrors(data.errors);
      },
    });
  };

  PrintModalQuote.prototype.printErrors = function (errors) {
    this.$el.find(".form_error > div").text("");
    if (errors) {
      Object.entries(errors).forEach(
        function (error) {
          this.$el
            .find(".form_error > div[name=" + error[0] + "]")
            .text("* " + error[1][0]);
        }.bind(this)
      );
    }
  };
})((window.sculpteo = window.sculpteo || {}));
